module.exports = __webpack_public_path__ + "media/images/stripes-ab4ab4f5fedd81f4345b474380ce1a0f.svg";